// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"680d31c0","68":"e871f771","598":"9c534af6","797":"57b466c9","848":"fd8dc5bf","999":"7ddd300d"}[chunkId] + ".chunk.js";
};